export default "__VITE_ASSET__CUSszHEo__"